import React, { useEffect, useState } from "react";
import Header from "../header/header";
import "./nozelData.css";
import { useSelector } from "react-redux";
import { authSelector } from "../../store/selectors/index";
import { message } from "antd";
import { getAllNozel } from "../../api/endpoints/saleData";
import socketIOClient from "socket.io-client";

const SingleNozzle = ({ nozzle, saleData }) => {
  console.log(nozzle, "nozzelelelele");
  console.log(saleData.sts, "sts oF nozel");
  // const getImageSource = () => {
  //   switch (saleData.sts) {
  //     case 0:
  //       return "./Nozzels/NozzelF.jpg";
  //     case 1:
  //       return "./Nozzels/off2.jpg";
  //     case 2:
  //       return "./Nozzels/NozzelF.jpg";
  //     case 3:
  //       return "./Nozzels/return.jpg";
  //     default:
  //       return null; // Handle other cases if needed
  //   }
  // };

  // const getHeading = () => {
  //   switch (saleData.sts) {
  //     case 0:
  //       return "Filling";
  //     case 1:
  //       return "Ideal";
  //     case 2:
  //       return "Ready to Start";
  //     case 3:
  //       return "Start";
  //     default:
  //       return ""; // Handle other cases if needed
  //   }
  // };

  //  const getImageSource = () => {
  //  switch (saleData.sts) {
  //  case 0:
  //  return "./Nozzels/NozzelF.jpg";
  //     case 1:
  //       return "./Nozzels/off2.jpg";
  //     case 2:
  //       return "./Nozzels/NozzelF.jpg";
  //     case 3:
  //       return "./Nozzels/return.jpg";
  //     default:
  //       return null; // Handle other cases if needed
  //   }
  // };

  // const getHeading = () => {
  //   switch (saleData.sts) {
  //     case 0:
  //       return "Filling";
  //     case 1:
  //       return "Ideal";
  //     case 2:
  //       return "Ready to Start";
  //     case 3:
  //       return "Start";
  //     default:
  //       return ""; // Handle other cases if needed
  //   }
  // };

  const getHeading = () => {
    switch (saleData.sts) {
      case 1:
        return "In Hand";
      case 3:
        return "Filling";
      case 4:
        return "Complete";
      default:
        return ""; // Handle other cases if needed
    }
  };
  const getImageSource = () => {
    switch (saleData.sts) {
      case 3:
        return "./Nozzels/NozzelF.jpg";
      case 4:
        return "./Nozzels/off2.jpg";
      case 1:
        return "./Nozzels/active.jpg";
      default:
        return null; // Handle other cases if needed
    }
  };

  return (
    <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 p-2">
      <div className="bgColour flex justify-center heading w-full">
        <h1>{getHeading()}</h1>
      </div>
      <div className="flex">
        <div className="w-2/4 pl-3 flex justify-center items-center">
          {getImageSource() && (
            <img src={getImageSource()} height="90rem" width="90rem" alt="" />
          )}
        </div>
        <div className="flex-col w-2/4 justify-between items-center">
          <div className=" flex font-medium mianHead justify-center mt-4">
            <h3>Nozel:</h3>
          </div>
          <div className="border-2 font-medium mianHead flex justify-center">
            <h3>{nozzle.nozelNumber}</h3>
          </div>
        </div>
      </div>
      <div className="flex mt-3 rateBg">
        <div className="w-1/2 flex pl-4 justify-start items-center font-medium mianHead">
          <h1>Rs:</h1>
        </div>
        <div className="w-1/2 flex numericValue items-center justify-center border-2 border-slate-400">
          <h1>{saleData.amount}</h1>
        </div>
      </div>
      <div className="flex  rateBg">
        <div className="w-1/2 flex pl-4 justify-start items-center font-medium mianHead">
          <h1>Liters:</h1>
        </div>
        <div className="w-1/2 flex numericValue items-center justify-center border-2 border-slate-400">
          <h1>{saleData.quantity}</h1>
        </div>
      </div>
      <div className="flex  rateBg">
        <div className="w-1/2 flex pl-4 justify-start items-center font-medium mianHead">
          <h1>Rate:</h1>
        </div>
        <div className="w-1/2 flex numericValue items-center justify-center border-2 border-slate-400">
          <h1>{saleData.rate}</h1>
          {/* <h1>{nozzle.rate}</h1> */}
        </div>
      </div>
    </div>
    // <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 p-2">
    //   <div className="flex bgColour justify-center heading w-full p-2">
    //     <h1 className="text-lg">{getHeading()}</h1>
    //   </div>
    //   <div className="flex flex-wrap">
    //     <div className="w-full sm:w-1/2 lg:w-2/4 pl-3">
    //       {getImageSource() && (
    //         <img
    //           src={getImageSource()}
    //           className="h-36 w-36 object-contain"
    //           alt=""
    //         />
    //       )}
    //     </div>
    //     <div className="w-full sm:w-1/2 lg:w-2/4 flex flex-col justify-between items-center">
    //       <div className="flex font-medium mainHead justify-center mt-4">
    //         <h3>Nozzle:</h3>
    //       </div>
    //       <div className="border-2 font-medium mainHead flex justify-center">
    //         <h3>{nozzle.nozelNumber}</h3>
    //       </div>
    //     </div>
    //   </div>
    //   <div className="flex mt-3 rateBg">
    //     <div className="w-1/2 flex pl-4 justify-start items-center font-medium mainHead">
    //       <h1>Rs:</h1>
    //     </div>
    //     <div className="w-1/2 flex numericValue items-center justify-center border-2 border-gray-400">
    //       <h1>{saleData.amount}</h1>
    //     </div>
    //   </div>
    //   <div className="flex rateBg">
    //     <div className="w-1/2 flex pl-4 justify-start items-center font-medium mainHead">
    //       <h1>Liters:</h1>
    //     </div>
    //     <div className="w-1/2 flex numericValue items-center justify-center border-2 border-gray-400">
    //       <h1>{saleData.quantity}</h1>
    //     </div>
    //   </div>
    //   <div className="flex rateBg">
    //     <div className="w-1/2 flex pl-4 justify-start items-center font-medium mainHead">
    //       <h1>Rate:</h1>
    //     </div>
    //     <div className="w-1/2 flex numericValue items-center justify-center border-2 border-gray-400">
    //       <h1>{nozzle.rate}</h1>
    //     </div>
    //   </div>
    // </div>
  );
};

const NozelData = () => {
  const { access_token } = useSelector(authSelector);
  const [allNozel, setAllNozel] = useState([]);
  const [saleData, setSaleData] = useState({});
  const [allNozelNumber, setAllNozelNumber] = useState([]);

  // Create a mapping from nozzle numbers to their index in saleData
  const nozzleIndexMap = {};

  const fetchDataFromAPI = async () => {
    const result = await getAllNozel(access_token);
    if (result.success) {
      setAllNozel(result.data);
      const allNozzleNumbers = result.data.map((nozzle) => nozzle.nozelNumber);
      setAllNozelNumber(allNozzleNumbers);
      // Initialize saleData using nozzle numbers as keys
      setSaleData(
        result.data.reduce((data, nozzle) => {
          console.log(nozzle, "nozzelll in state");
          data[nozzle.nozelNumber] = {
            nozelNumber: nozzle.nozelNumber, // Add the nozzle number
            amount: nozzle.amount,
            quantity: nozzle.quantity,
            sts: nozzle.sts,
            rate: nozzle.rate,
          };
          nozzleIndexMap[nozzle.nozelNumber] = nozzle.nozelNumber;
          return data;
        }, {})
      );
      console.log(saleData, "saleData IN fetch");
    } else {
      message.warning(result.message);
    }
  };

  useEffect(() => {
    fetchDataFromAPI();

    // console.log(saleData, "saleData in useEffect");
  }, [access_token]);

  useEffect(() => {
    const socket = socketIOClient("http://localhost:4000");

    socket.on("nozelData", (nozelData) => {
      console.log(nozelData, "nozelDataAAAAAAAAAAAAAA");
      // Update the saleData based on the nozzle number received
      for (const nozzleData of nozelData) {
        const nozzleNumber = nozzleData.nozelNumber; // Convert to integer
        console.log(nozzleNumber, "nozelNumber");
        console.log(nozzleData.nozelNumber, "nozelData");
        console.log(nozzleData, "nozel");

        if (nozzleNumber in saleData) {
          setSaleData((prevData) => {
            const newData = { ...prevData };
            console.log(newData, "newData");

            const updatedNozzleData = {
              amount: nozzleData.amount,
              quantity: nozzleData.quantity,
              sts: nozzleData.sts, // Update 'sts' in saleData
              rate: nozzleData.rate,
            };
            newData[nozzleNumber] = updatedNozzleData;
            return newData;
          });
        } else {
          console.log(`Nozzle ${nozzleNumber} not found in saleData  `);
        }
      }
    });

    return () => socket.disconnect();
  }, [saleData]);

  console.log(saleData, "saleData");
  console.log(allNozelNumber, "allNozelNumber");

  return (
    <>
      <div className="sticky w-full">
        <Header />
      </div>
      <div className="flex flex-wrap justify-evenly">
        {allNozel.length > 0 ? (
          allNozel.map((nozzle) => (
            <SingleNozzle
              key={nozzle.nozelNumber}
              nozzle={nozzle}
              saleData={saleData[nozzle.nozelNumber]}
            />
          ))
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default NozelData;
